import { TourModel } from 'api-hooks/tour/tour-list/tour-detail';
import { AuthorizationRules } from 'common/constants';
import { PopoverMenuType } from 'components/popover';
import { useAuthorization } from 'hooks/use-authorization';
import useDrawer, { DrawerProvider } from 'hooks/use-drawer';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import ListPurchasePanel from '../panel/purchase-list-panel';

export default function useTourPurchaseListAction(tour: TourModel) {
  const { t } = useTranslation();
  const { can } = useAuthorization();
  const drawer = useDrawer();
  const id = tour.id;

  const tourPurchaseListPermission = can(AuthorizationRules.ToursGetPurchase);
  const onGetTourPurchaseList = React.useCallback(() => {
    drawer.showCustom({
      render: (onClose) => (
        <DrawerProvider>
          <ListPurchasePanel id={id} onClose={onClose} />
        </DrawerProvider>
      ),
    });
  }, [drawer, id]);

  const tourPurchaseListAction: PopoverMenuType = {
    key: `tour-purchase-list-${id}`,
    label: t('common:purchase_list'),
    onClick: onGetTourPurchaseList,
    isAllowed: tourPurchaseListPermission,
  };

  return {
    tourPurchaseListPermission,
    onGetTourPurchaseList,
    tourPurchaseListAction,
  };
}
